import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coffee, GlassWater, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";

export default function WeeklyMenusPage() {
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    api.get("/weekly-menus").then((r) => setMenus(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="weekly-menus-page">
      <p className="gold-label mb-3">Renouvelé chaque semaine</p>
      <h1 className="font-serif-elegant text-4xl sm:text-5xl font-bold mb-4">Menu de la semaine</h1>
      <p className="text-gray-300 max-w-2xl mb-2">
        Entrée + Plat + Dessert + Café + <span className="text-[#D4AF37]">Boisson incluse</span> — 24,90 € TTC
      </p>
      <p className="text-sm text-gray-400 mb-12">Composez votre menu parmi les choix de la semaine.</p>

      {menus.map((m) => (
        <div key={m.id} className={`ic-card !transform-none overflow-hidden mb-10 ${!m.available ? "opacity-60" : ""}`} data-testid={`weekly-menu-card-${m.id}`}>
          {m.photo_url && <img src={m.photo_url} alt={m.title} className="h-56 w-full object-cover" />}
          <div className="p-8 sm:p-10">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <h2 className="font-serif-elegant text-3xl font-semibold text-[#D4AF37]">{m.title}</h2>
              {!m.available && <span className="text-xs text-[#C8102E] border border-[#C8102E]/40 rounded-full px-3 py-1">Indisponible</span>}
            </div>
            {m.start_date && (
              <p className="text-xs text-gray-500 mt-1">
                Du {new Date(m.start_date + "T00:00:00").toLocaleDateString("fr-FR")} au {new Date(m.end_date + "T00:00:00").toLocaleDateString("fr-FR")}
              </p>
            )}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-8">
              {[["Entrées au choix", m.entrees], ["Plats au choix", m.plats], ["Desserts au choix", m.desserts]].map(([label, choices]) => (
                <div key={label}>
                  <p className="gold-label mb-3">{label}</p>
                  <ul className="space-y-2.5">
                    {(choices || []).map((c) => (
                      <li key={c} className="flex items-start gap-2 text-sm text-gray-200">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-1.5 shrink-0" /> {c}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="flex flex-wrap gap-6 mt-8 pt-6 border-t border-white/10 text-sm text-gray-300">
              <span className="flex items-center gap-2"><Coffee size={15} className="text-[#D4AF37]" /> Café inclus</span>
              <span className="flex items-start gap-2"><GlassWater size={15} className="text-[#D4AF37] mt-0.5" /> Boisson incluse : {(m.drinks || []).join(", ")}</span>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-4 mt-8">
              <span className="text-3xl font-medium">{m.price.toFixed(2).replace(".", ",")} €<span className="text-xs text-gray-500 ml-1">TTC</span></span>
              {m.available && (
                <Link to={`/reserver?menu=${m.id}`} data-testid={`weekly-menu-reserve-${m.id}`} className="btn-gold">
                  <CheckCircle2 size={16} /> Réserver avec ce menu
                </Link>
              )}
            </div>
          </div>
        </div>
      ))}
      {menus.length === 0 && <p className="text-gray-400">Le menu de la semaine sera bientôt publié.</p>}
    </div>
  );
}
